import { Svg } from "common/assets"
import { ButtonClose, IconClose,  ContentWrapper, StyledModal} from "./styled"
import { TModalProps } from "./types";


export const Modal = ({
    modalActive,
    setModalActive,
    top,
    children,
    ...props
}: TModalProps) => {
    
    modalActive
        ? (document.body.style.overflow = "hidden")
        : (document.body.style.overflow = "inherit");
    
    return (
        <StyledModal active={modalActive ? "active" : ""}>
            <ButtonClose onClick={() => setModalActive(!modalActive)}>
                <IconClose>
                    <use href={Svg.sprite + "#icon-close"} />
                </IconClose>
            </ButtonClose>
            <ContentWrapper top={top}>
                {children}
            </ContentWrapper>
        </StyledModal>
    )
}